var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideItemsGlowBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1385,
    height: 1425,
    viewBox: "0 0 1385 1425",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_1877_14111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.763 730.005C1130.53 903.597 903.652 1075 684.254 1075C464.857 1075 287 912.703 287 712.5C287 512.297 464.857 350 684.254 350C903.652 350 1291.19 487.609 789.763 730.005Z",
    fill: "#5837FF",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14111",
    x: -63,
    y: 0,
    width: 1448,
    height: 1425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_1877_14111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideItemsGlowBg);
export default __webpack_public_path__ + "static/media/SlideItemsGlowBg.8197555ceff342db3af0c7a3fde31de6.svg";
export { ForwardRef as ReactComponent };